/**
 * Converts from frontend userDirectory filter to backend storage client filter.
 */
export function useUserDirectoryFilter({ filterData }) {
    return { data: mapUserDirectoryFilterData(filterData), isLoading: false };
}
export function mapUserDirectoryFilterData(filterData) {
    const { partialSearch, firstName, lastName, email, contactEmail, contactPhoneNumber, pagerNumber, orgAssociation, orgMembership, city, state, county, postalCode, } = checkAndRemoveEmptyArrays(filterData);
    const filter = [];
    if (partialSearch) {
        filter.push({
            column: 'partialSearch',
            op: 'contains',
            value: partialSearch,
        });
    }
    if (firstName) {
        filter.push({
            column: 'firstName',
            op: '=',
            value: firstName,
        });
    }
    if (lastName) {
        filter.push({
            column: 'lastName',
            op: '=',
            value: lastName,
        });
    }
    if (email) {
        filter.push({
            column: 'email',
            op: '=',
            value: email,
        });
    }
    if (contactEmail) {
        filter.push({
            column: 'contactEmails',
            op: 'contains',
            value: contactEmail,
        });
    }
    if (contactPhoneNumber) {
        filter.push({ column: 'contactPhoneNumbers', op: 'overlap', value: [contactPhoneNumber] });
    }
    if (pagerNumber) {
        filter.push({ column: 'pagerNumbers', op: 'overlap', value: [pagerNumber] });
    }
    if (orgAssociation) {
        filter.push({ column: 'orgAssociation', op: 'overlap', value: orgAssociation });
    }
    if (city) {
        filter.push({
            column: 'city',
            op: '=',
            value: city,
        });
    }
    if (postalCode) {
        filter.push({
            column: 'postalCode',
            op: '=',
            value: postalCode,
        });
    }
    if (state) {
        filter.push({
            column: 'state',
            op: '=',
            value: state,
        });
    }
    if (county) {
        filter.push({
            column: 'county',
            op: '=',
            value: county,
        });
    }
    if (orgMembership === null || orgMembership === void 0 ? void 0 : orgMembership.length) {
        filter.push({
            column: 'orgMembership',
            op: 'overlap',
            value: orgMembership,
        });
    }
    return filter;
}
function checkAndRemoveEmptyArrays(filterData) {
    return filterData
        ? Object.fromEntries(Object.entries(filterData).filter(([key, value]) => {
            if (Array.isArray(value) && value.length === 0) {
                console.warn('Account filter data has an empty array for ' + key + ' this should not happen');
                return false;
            }
            else {
                return true;
            }
        }))
        : {};
}
